var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "app/translate/translate.service";
import { FilterFormService } from "app/views/filter_form/filter_form.service";
import { EventsService } from "app/lib/EventsService";
import { BaseComponent } from "app/views/base.component";
import { HelperService } from "../../lib/helper.service";
import { HttpClient } from "@angular/common/http";
import { ChartParams } from "../../views/chart/chart.component";
import { ModalService } from "app/views/modal/base_modal.component";
import { getTimeAsIntervals } from "../../lib/lib";
import * as qs from 'qs';
import { TemplateBillingDetailsComponent } from "./details/template_billing_details.component";
import { BillingService2 } from "../billing.service";
var TemplateBillingComponent = /** @class */ (function (_super) {
    __extends(TemplateBillingComponent, _super);
    function TemplateBillingComponent(eventsService, activatedRoute, translate, router, modalService, filter, http, helper, service2) {
        var _this = _super.call(this, eventsService, service2, activatedRoute, filter, translate) || this;
        _this.eventsService = eventsService;
        _this.activatedRoute = activatedRoute;
        _this.translate = translate;
        _this.router = router;
        _this.modalService = modalService;
        _this.filter = filter;
        _this.http = http;
        _this.helper = helper;
        _this.service2 = service2;
        _this.chart = new ChartParams();
        _this.addFilterParams = {
            userType: 'user',
            isBilling: true,
            dateFilters: ['dateCreated', 'datePaid', 'dateSiteCreated'],
            dateType: 'datePaid'
        };
        _this.filter.addFilters.push('promocode');
        _this.chart.setOptions({
            title: '',
            names: {
                'paidCount': _this.translate.__A('common.paidCount')
            },
            colors: {
                'paidCount': '#1f77b4'
            },
            showLabels: [
                'paidCount'
            ]
        });
        return _this;
    }
    TemplateBillingComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTotal()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getChart()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.getPagination()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TemplateBillingComponent.prototype.getTotal = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.dontLoad.total) {
                            return [2 /*return*/, true];
                        }
                        this.info = null;
                        this.chart.showLoader();
                        _a = this;
                        return [4 /*yield*/, this.service2.templateBilling.total(this.filter.filterParams).toPromise()];
                    case 1:
                        _a.info = _b.sent();
                        this.chart.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    TemplateBillingComponent.prototype.getChart = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var charts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.dontLoad.chart) {
                            return [2 /*return*/, true];
                        }
                        this.chart.showLoader();
                        return [4 /*yield*/, this.service2.templateBilling.chart(this.filter.getCopyFilterParams(params)).toPromise()];
                    case 1:
                        charts = (_a.sent()).charts;
                        this.chart.data = charts;
                        this.chart.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    TemplateBillingComponent.prototype.getPagination = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, pagination;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        if (!(me.filter.filterParams.period == 'summary')) return [3 /*break*/, 2];
                        return [4 /*yield*/, me.getStats()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 2:
                        me.paginationLoader = true;
                        return [4 /*yield*/, me.service2.templateBilling.pagination(me.filter.filterParams).toPromise()];
                    case 3:
                        pagination = _a.sent();
                        me.pagination.fill(pagination);
                        if (pagination) {
                            me.updateLinks(me.service2.templateBilling.getRealFullRoute());
                        }
                        me.paginationLoader = false;
                        return [4 /*yield*/, me.getStats()];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TemplateBillingComponent.prototype.onPageChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                this.filter.filterParams.page = this.pagination.page;
                this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);
                params = this.filter.getApplyFilters(this.filter.filterParams), url = this.router.url.split('?')[0];
                params = qs.stringify(params, { encode: false });
                this.router.navigateByUrl(url + "?" + params, { relativeTo: this.activatedRoute });
                this.dontLoad = {
                    total: true,
                    chart: true,
                    pagination: true
                };
                return [2 /*return*/];
            });
        });
    };
    TemplateBillingComponent.prototype.getStats = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, stats, _i, _a, stat, dates;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        me = this;
                        me.paginationLoader = true;
                        return [4 /*yield*/, me.service2.templateBilling.stats(me.filter.getCopyFilterParams({
                                paginationDate: me.pagination.getDate()
                            })).toPromise()];
                    case 1:
                        stats = (_b.sent()).stats;
                        me.stats = stats;
                        for (_i = 0, _a = me.stats; _i < _a.length; _i++) {
                            stat = _a[_i];
                            dates = getTimeAsIntervals({
                                timestamp: stat.timestamp,
                                period: me.filter.filterParams.period
                            });
                            if (dates.length === 2) {
                                stat.currentPeriod = dates[0] + '-' + dates[1];
                            }
                            else {
                                stat.currentPeriod = dates[0];
                            }
                            stat.day = new Date(stat.timestamp).getDay();
                            if (stat.currentPeriod == '')
                                stat.currentPeriod = 'summary';
                        }
                        me.paginationLoader = false;
                        me.dontLoad = {};
                        return [2 /*return*/];
                }
            });
        });
    };
    TemplateBillingComponent.prototype.showDetails = function (timestamp, period) {
        return __awaiter(this, void 0, void 0, function () {
            var modalRef, stats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        modalRef = this.modalService.open(TemplateBillingDetailsComponent, {
                            title: period,
                        }, { size: 'hg' });
                        return [4 /*yield*/, this.service2.templateBilling.detail(this.filter.getCopyFilterParams({ timestamp: timestamp })).toPromise()];
                    case 1:
                        stats = (_a.sent()).stats;
                        modalRef.componentInstance.details = stats;
                        return [2 /*return*/];
                }
            });
        });
    };
    return TemplateBillingComponent;
}(BaseComponent));
export { TemplateBillingComponent };
